import React, { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom';
import styles from '../layout/Layout.module.css';
import Footer from '../layout/footer/Footer';
import Header from '../layout/header/Header';

const KeyPickupDropLayout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    localStorage.removeItem('visitor');
    // localStorage.removeItem('visitorAccessToken');
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, [pathname]);

  return (
    <div className={styles.screenContainer}>
      <Header isVendor />
      <Outlet />
      <Footer />
    </div>
  )
}

export default KeyPickupDropLayout